import { connect } from 'react-redux'
import * as actions from './actions'
import { fetchContactList } from '../Contacts/actions'
import Room from './Room'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingRooms: state.rooms.isFetchingRooms,
    isFetchingPreviousRooms: state.rooms.isFetchingPreviousRooms,
    isFetchingConferenceDetails: state.rooms.isFetchingConferenceDetails,
    isFetchingParticipantList: state.rooms.isFetchingParticipantList,
    isFetchingRecordList: state.rooms.isFetchingRecordList,
    isFetchingList: state.contacts.isFetchingList,
    conferenceDetails: state.rooms.conferenceDetails,
    selectConferenceId: state.rooms.selectConferenceId,
    participants: state.rooms.participants,
    userid: state.loginLayout.profile.userid,
    contacts: state.contacts.contacts,
    recordings: state.rooms.recordings,
    scheduleUpdated: state.rooms.scheduleUpdated,
    upCommingRooms: state.rooms.upCommingRooms,
    previousRooms: state.rooms.previousRooms,
    upcoming: state.rooms.upcoming,
    startDate: state.rooms.startDate,
    name: state.loginLayout.profile.name,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  updateConferenceDetails: (token, conferenceId, name, description, password) =>
    dispatch(
      actions.updateConferenceDetails(
        token,
        conferenceId,
        name,
        description,
        password
      )
    ),
  updateConferenceSchedule: (token, conferenceId, startDate) =>
    dispatch(actions.updateConferenceSchedule(token, conferenceId, startDate)),
  updateConferenceSettings: (token, conferenceId, language, timezone, bitrate, turn, codec) =>
    dispatch(
      actions.updateConferenceSettings(token, conferenceId, language, timezone, bitrate, turn, codec)
    ),
  deleteConference: (token, conferenceId) =>
    dispatch(actions.deleteConference(token, conferenceId)),
  fetchParticipantList: (token, conferenceId) =>
    dispatch(actions.fetchParticipantList(token, conferenceId)),
  addParticipant: (token, name, email, role, conferenceId) =>
    dispatch(actions.addParticipant(token, name, email, role, conferenceId)),
  inviteParticipant: (token, participantId, conferenceId) =>
    dispatch(actions.inviteParticipant(token, participantId, conferenceId)),
  deleteParticipant: (token, participantId, conferenceId) =>
    dispatch(actions.deleteParticipant(token, participantId, conferenceId)),
  fetchRecordList: (token, conferenceId) =>
    dispatch(actions.fetchRecordList(token, conferenceId)),
  fetchContactList: token => dispatch(fetchContactList(token)),
  importParticipants: (token, contactId, conferenceId) =>
    dispatch(actions.importParticipants(token, contactId, conferenceId)),
  scheduleSubmitted: bool => dispatch(actions.scheduleSubmitted(bool)),
  respondToInvitation: (token, bool, id, authToken) =>
    dispatch(actions.respondToInvitation(token, bool, id, authToken))
})

const RoomContainer = connect(mapStateToProps, mapDispatchToProps)(Room)

export default RoomContainer



// WEBPACK FOOTER //
// ./src/routes/Room/RoomContainer.js